import React from "react"
import Ximg from "../assets/icons/no_cubre.png"
import Checkimg from "../assets/icons/icono_exitos.png"
import "../Components/List/PolicyList.css"

const parseIcons = {
    "No Cubre": <img className="img-icon-table" src={Ximg} alt="No"></img>,
    "NO": <img className="img-icon-table" src={Ximg} alt="No"></img>,
    "NO APLICA": <img className="img-icon-table" src={Ximg} alt="No"></img>,
    "SI": <img className="img-icon-table" src={Checkimg} alt="Si"></img>,
    "Si Cubre": <img className="img-icon-table" src={Checkimg} alt="Si"></img>,
    "SI AMPARA": <img className="img-icon-table" src={Checkimg} alt="Si"></img>,
}

const parseIconsHorizontalCards = {
    "No Cubre": "fa fa-times card-value-icon",
    "NO": "fa fa-times card-value-icon",
    "NO APLICA": "fa fa-times card-value-icon",
    "SI": "fa fa-check card-value-icon",
    "Si Cubre": "fa fa-check card-value-icon",
    "SI AMPARA": "fa fa-check card-value-icon"
}

const getIcon = (value="SI")=> {
    const icon = parseIconsHorizontalCards [value];
    if (icon){
        return icon;
    }
    return  "fa fa-check card-value-icon";
}

const parseIconsColorsHorizontalCards = {
    "No Cubre": "red",
    "NO": "red",
    "NO APLICA": "red",
    "SI": "green",
    "Si Cubre": "green",
    "SI AMPARA": "green"
}

const getIconColor = (value="SI")=> {
    const icon = parseIconsColorsHorizontalCards [value];
    if (icon){
        return icon;
    }
    return  "green";
}

export { parseIcons, getIcon, getIconColor };

